<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Prüfung {{ lesson().StartTime | date : "dd.MM.yyyy" }}</ion-title>
    <ion-buttons slot="end">
      <ion-button
        [ngClass]="{ 'motion-preset-confetti': isClicked(), 'motion-duration-700': isClicked() }"
        (click)="save()"
        [disabled]="!this.examForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="examForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <!-- form with examPassed and exam notes - should fill one whole page from design perspective -->
    <ion-list class="mt-5 mb-5">
      <ion-item>
        <ion-select
          label="Prüfungsresultat"
          cancelText="Abbrechen"
          formControlName="passed_test"
          aria-label="Bestanden"
          interface="action-sheet"
        >
          <ion-select-option destructive [value]="true"
            >Bestanden</ion-select-option
          >
          <ion-select-option [value]="false">Nicht bestanden</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item lines="full">
        <ion-textarea
          class="textarea"
          placeholder="Notiz"
          autoGrow
          formControlName="education_notes"
        >
        </ion-textarea>
      </ion-item>
    </ion-list>
  </form>
</ion-content>
